import { styled } from '@mui/system';

const Logo = styled('img')({
  height: 40,
});

export { Logo };
